'use client';

// Windowed page list: always show first + last, the current page and its
// immediate neighbours, and an ellipsis wherever pages are skipped. Keeps the
// rendered button count bounded (~7) no matter how many pages exist, so the
// footer never overflows on a phone.
function pageWindow(page: number, pageCount: number, neighbours = 1): (number | 'gap')[] {
  const first = 1;
  const last = pageCount;
  const left = Math.max(first, page - neighbours);
  const right = Math.min(last, page + neighbours);
  const out: (number | 'gap')[] = [first];
  if (left > first + 1) out.push('gap');
  for (let p = left; p <= right; p++) {
    if (p !== first && p !== last) out.push(p);
  }
  if (right < last - 1) out.push('gap');
  if (last !== first) out.push(last);
  return out;
}

export function Pagination({
  page,
  pageCount,
  onChange,
  ariaLabel = 'Paginasi',
}: {
  page: number;
  pageCount: number;
  onChange: (page: number) => void;
  ariaLabel?: string;
}) {
  if (pageCount <= 1) return null;
  const items = pageWindow(page, pageCount);
  return (
    <nav className="mx-pagination" aria-label={ariaLabel}>
      <button
        type="button"
        className="mx-pagination__btn"
        aria-label="Sebelumnya"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
      >
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="m15 18-6-6 6-6" />
        </svg>
      </button>
      {items.map((it, i) =>
        it === 'gap' ? (
          <span key={`gap-${i}`} className="mx-pagination__gap" aria-hidden="true">…</span>
        ) : (
          <button
            key={it}
            type="button"
            className={`mx-pagination__btn${it === page ? ' mx-pagination__btn--active' : ''}`}
            aria-current={it === page ? 'page' : undefined}
            aria-label={`Halaman ${it}`}
            onClick={() => onChange(it)}
          >
            {it}
          </button>
        ),
      )}
      <button
        type="button"
        className="mx-pagination__btn"
        aria-label="Berikutnya"
        disabled={page >= pageCount}
        onClick={() => onChange(page + 1)}
      >
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="m9 18 6-6-6-6" />
        </svg>
      </button>
    </nav>
  );
}
